module.exports = __webpack_public_path__ + "img/premium-dashboard.68b3bbb8.svg";